import { createFileRoute } from '@tanstack/react-router';

import type { AdminUserSort, DepartmentSort, IDNSort } from '~/api/types';
import { USER_ROLES } from '~/features/auth/roles';
import type { CustomerAdminUsersTabsValue } from '~/features/customerAdministration/users/constants';
import { AdminUsers } from '~/features/customerAdministration/users/users';
import type { CustomerAdminUsersSearchParams } from '~/types/AdminUsersRoute';
import { protectedRoute } from '~/utils/routesAuthorization';

export const Route = createFileRoute('/customer-admin/users')({
  component: AdminUsers,
  validateSearch: (
    search: Record<string, unknown>,
  ): CustomerAdminUsersSearchParams<
    CustomerAdminUsersTabsValue,
    AdminUserSort | DepartmentSort | IDNSort
  > => {
    // Validate and parse the search params into a typed state
    const defaultSortDir = search.sortDir === 'asc' ? 'asc' : 'desc';
    const sortDir = search.sortDir ? defaultSortDir : undefined;
    const filters = search.filters ?? undefined;
    const departmentId =
      typeof search.departmentId === 'string' ? search.departmentId : undefined;
    const IDNId = typeof search.IDNId === 'string' ? search.IDNId : undefined;
    const IDN = typeof search.IDN === 'string' ? search.IDN : undefined;

    return {
      page: search.page ? Number(search.page) || 1 : undefined,
      sort:
        (search.sort as AdminUserSort | DepartmentSort | undefined) ??
        undefined,
      search: search.search ? decodeURI(search.search as string) : undefined,
      sortDir,
      departmentId,
      filters,
      IDN,
      IDNId,
    };
  },
  beforeLoad: () => {
    protectedRoute({
      roles: [USER_ROLES.AdminAbbott, USER_ROLES.AbbottUser],
    });
  },
});
